
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dcl-dashboard",
      function () {
        return require("private-next-pages/dcl-dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dcl-dashboard"])
      });
    }
  